webpackJsonp([207004445795019],{

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(7);
	
	var _buttonComponent = __webpack_require__(17);
	
	var _buttonComponent2 = _interopRequireDefault(_buttonComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactForm = function (_React$Component) {
	  (0, _inherits3.default)(ContactForm, _React$Component);
	
	  function ContactForm(props) {
	    (0, _classCallCheck3.default)(this, ContactForm);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	  }
	
	  ContactForm.prototype.render = function render() {
	    return _react2.default.createElement(
	      _reactstrap.Col,
	      { md: "8", className: this.props.className },
	      _react2.default.createElement(
	        _reactstrap.Form,
	        {
	          name: "contact",
	          method: "post",
	          netlify: "true",
	          "data-netlify-honeypot": "bot-field"
	        },
	        _react2.default.createElement("input", { type: "hidden", name: "form-name", value: "contact" }),
	        _react2.default.createElement(
	          _reactstrap.FormGroup,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Label,
	            { "for": "inputName" },
	            "Name*"
	          ),
	          _react2.default.createElement(_reactstrap.Input, {
	            type: "text",
	            name: "name",
	            id: "name",
	            className: "form-control-lg",
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          _reactstrap.FormGroup,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Label,
	            { "for": "inputEmail" },
	            "Email*"
	          ),
	          _react2.default.createElement(_reactstrap.Input, {
	            type: "email",
	            name: "email",
	            id: "email",
	            className: "form-control-lg",
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          _reactstrap.FormGroup,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Label,
	            { "for": "inputPhone" },
	            "Phone"
	          ),
	          _react2.default.createElement(_reactstrap.Input, {
	            type: "tel",
	            name: "phone",
	            id: "phonenumber",
	            className: "form-control-lg"
	          })
	        ),
	        _react2.default.createElement(
	          _reactstrap.FormGroup,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Label,
	            { "for": "inputMessage" },
	            "Message*"
	          ),
	          _react2.default.createElement(_reactstrap.Input, {
	            type: "textarea",
	            name: "message",
	            className: "form-control form-control-lg",
	            id: "message",
	            rows: "2",
	            required: true
	          })
	        ),
	        _react2.default.createElement(
	          _buttonComponent2.default,
	          { large: true, link: "/thanks" },
	          "Send Inquiry"
	        )
	      )
	    );
	  };
	
	  return ContactForm;
	}(_react2.default.Component);
	
	exports.default = ContactForm;
	module.exports = exports["default"];

/***/ }),

/***/ 1873:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _classCallCheck2 = __webpack_require__(3);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(5);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(4);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _path = __webpack_require__(31);
	
	var _graphql = __webpack_require__(25);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _siteConfig = __webpack_require__(19);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _seoComponent = __webpack_require__(27);
	
	var _seoComponent2 = _interopRequireDefault(_seoComponent);
	
	var _fadeIn = __webpack_require__(18);
	
	var _fadeIn2 = _interopRequireDefault(_fadeIn);
	
	var _pageWrapper = __webpack_require__(34);
	
	var _pageWrapper2 = _interopRequireDefault(_pageWrapper);
	
	var _pageHeader = __webpack_require__(32);
	
	var _pageHeader2 = _interopRequireDefault(_pageHeader);
	
	var _pageSection = __webpack_require__(33);
	
	var _pageSection2 = _interopRequireDefault(_pageSection);
	
	var _contactForm = __webpack_require__(141);
	
	var _contactForm2 = _interopRequireDefault(_contactForm);
	
	var _press = __webpack_require__(40);
	
	var _press2 = _interopRequireDefault(_press);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// find page title by path
	var findNode = function findNode(path, data) {
	  return data.allMarkdownRemark.edges.map(function (edge) {
	    return edge.node.frontmatter;
	  }).filter(function (r) {
	    return r.path === path;
	  }).pop();
	};
	
	var Template = function (_React$Component) {
	  (0, _inherits3.default)(Template, _React$Component);
	
	  function Template() {
	    (0, _classCallCheck3.default)(this, Template);
	    return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.componentDidMount = function componentDidMount() {
	    this.props.history.push("/");
	  };
	
	  Template.prototype.render = function render() {
	    var page = this.props.data.markdownRemark;
	
	    var path = this.props.data.markdownRemark.frontmatter.path;
	    var pageNode = this.props.data.markdownRemark;
	    return _react2.default.createElement(
	      _pageWrapper2.default,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: page.frontmatter.title + " | " + _siteConfig2.default.siteTitle }),
	      _react2.default.createElement(_seoComponent2.default, { pagePath: path, pageNode: pageNode, pageSEO: true }),
	      _react2.default.createElement(_pageHeader2.default, {
	        title: page.frontmatter.titleLong,
	        subtitle: page.frontmatter.description,
	        cta: page.frontmatter.cta,
	        ctaLink: page.frontmatter.ctaLink,
	        backgroundImage: page.frontmatter.coverImage.childImageSharp.resolutions.src
	      }),
	      _react2.default.createElement(
	        _fadeIn2.default,
	        null,
	        _react2.default.createElement(_pageSection2.default, { className: "my-5" }),
	        _react2.default.createElement(
	          _pageSection2.default,
	          { title: "Press", className: "bg-white pt-3 pb-3" },
	          _react2.default.createElement(_press2.default, { data: this.props.data.press.edges }),
	          " "
	        )
	      )
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-thanks-js-968ce0d43a5198646044.js